module.exports = __webpack_public_path__ + "static/media/ExpenseMate.9732000b.png";